var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-wrapper",style:({ height: '400px', width: '800px' }),attrs:{"id":"idrtd"}})}
var staticRenderFns = []

export { render, staticRenderFns }